import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, LabelList } from "recharts";
import { useTranslation } from "react-i18next";

const reorderData = (data) => {
  const order = ["Financial", "Operational", "Reputational"];
  return [...data].sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
};

const RiskSummary = ({ height, data }) => {
  const { t } = useTranslation();
  const reorderedData = data ? reorderData(data) : [];
  const [compact, setCompact] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const fn = () => setCompact(mq.matches);
    fn();
    mq.addEventListener("change", fn);
    return () => mq.removeEventListener("change", fn);
  }, []);

  const chartHeight =
    typeof height === "number" && height > 0 ? Math.max(height, compact ? 220 : 180) : 260;

  return (
    <ResponsiveContainer width="100%" height={chartHeight}>
      <BarChart
        data={reorderedData}
        margin={{
          top: 15,
          right: 10,
          left: 10,
          bottom: 0,
        }}
      >
        <XAxis dataKey="name" />
        <YAxis hide />
        <Tooltip />
        <Legend
          layout="horizontal"
          verticalAlign={compact ? "bottom" : "top"}
          align="center"
          wrapperStyle={{ fontSize: compact ? 10 : 12 }}
        />
        <Bar name={t("riskCenter.levels.inherent")} dataKey="Inherent" stackId="a" fill="#F07167">
          {!compact && (
            <LabelList dataKey="Inherent" position="insideTop" style={{ fill: "black", fontSize: 11 }} />
          )}
        </Bar>
        <Bar name={t("riskCenter.levels.residual")} dataKey="Residual" stackId="a" fill="#FED4AE">
          {!compact && (
            <LabelList dataKey="Residual" position="insideTop" style={{ fill: "black", fontSize: 11 }} />
          )}
        </Bar>
        <Bar name={t("riskCenter.levels.future")} dataKey="Future" stackId="a" fill="#09A6B0">
          {!compact && <LabelList dataKey="Future" position="top" style={{ fill: "black", fontSize: 11 }} />}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RiskSummary;
